module.exports = __webpack_public_path__ + "static/media/logo-green-big.79669e18.svg";